import CardHeader from '@creator/ui/components/Card/CardHeader';
import { cn } from '@creator/ui/utils/ui';
import { useStoreState } from '@src/model/hooks';
import { usePost } from '@src/store/posts/hooks/usePost';
import { propsEqualityFn, storeEqualityFn } from '@src/utils/object-utils/object-utils';
import { memo } from 'react';
import type { FC } from 'react';
import PostBasicInfo, { type PostBasicInfoProps } from '../Upvote/PostBasicInfo/PostBasicInfo';
import Text from '@creator/ui/components/Text/Text';
import PostMenuPopover from '../PostMenuPopover/PostMenuPopover';

export interface PostCardHeaderProps {
    className?: string;
    postId: string;
    tokenName: string;
    showPostTitle?: boolean;
}

const PostCardHeader: FC<PostCardHeaderProps> = props => {
    const { tokenName, postId, className } = props;

    const post = usePost(postId);
    const token = useStoreState(state => state.token.getToken(tokenName), storeEqualityFn);

    const renderPostBasicInfo = () => {
        if (!post) return null;

        const infoProps: PostBasicInfoProps = {
            className: 'text-sm',
            publisherName: post.publisherName,
            publisherProfileName: post.createdByWhitelistedUser ? post.publisherProfileName : '',
            publisherSlugUrl: post.publisherSlugUrl,
            createdAt: post.createdAt,
            tokenName: post.tokenName,
            showPartnerLabel: post.createdByWhitelistedUser,
            communityName: token?.title,
        };

        return <PostBasicInfo {...infoProps} />;
    };

    function renderTitle() {
        const { showPostTitle } = props;
        if (!showPostTitle || !post) return null;
        return (
            <div className="flex items-center justify-between mb-3">
                <Text enableMultiline={true} as="h1" className="text-base font-bold lg:text-lg">
                    {post?.title}
                </Text>
                <PostMenuPopover postId={postId} className="" tokenName={tokenName} />
            </div>
        );
    }

    return (
        <div className={cn('relative', className)}>
            {renderTitle()}
            {renderPostBasicInfo()}
        </div>
    );
};

export default memo(PostCardHeader, propsEqualityFn);
